import { styled } from '@mui/material';

export const ListW = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`;
